import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Copy: FC<IIconsProps> = ({ color, size = IconScale.M }: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="9"
        y="9"
        width="13"
        height="13"
        rx="2"
        stroke={color}
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 1C2.34315 1 1 2.34315 1 4V13C1 14.6569 2.34315 16 4 16H6V14H4C3.44772 14 3 13.5523 3 13V4C3 3.44772 3.44772 3 4 3H13C13.5523 3 14 3.44772 14 4V6H16V4C16 2.34315 14.6569 1 13 1H4Z"
        fill={color}
      />
    </svg>
  );
};

export default Copy;
